import { httpV1 as http } from '@/services/api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

/** General  */

export async function getUsers(params = {}) {
  const apiQueryParams = new URLSearchParams(params).toString();
  let apiUrl = '/users';

  if (apiQueryParams !== '') apiUrl += `?${apiQueryParams}`;

  const { data } = await http.get(apiUrl);
  return data;
}

export async function getInfoUser() {
  const { data } = await http.get('/users/me?with_account=1&check_for_antifraud=1');
  return data;
}

/**
 * Update User based on User ID
 * @function updateUserByUserId
 * @param {object} params - The Params with the values to be changed
 * @param {string} id - The User ID
 * @returns any
 */
export async function updateUserByUserId(params, id) {
  return http.put(`/users/${id}`, params);
}

export async function logoutUser() {
  return http.post('/users/logout');
}

export async function getResponsibleByID(id, params = null) {
  return http.get(`/responsibles/${id}`, { params });
}

export async function updateAccounts(accountId, params) {
  return http.put(`/clients/${accountId}`, params);
}

export async function getCollabs(params) {
  return http.get(`${ALT_API_URL}/employees`, { params });
}

export async function collabsCSV(params) {
  return http.get(`${ALT_API_URL}/employees?output=csv`, { params });
}

/** Promoters */

export async function savePromoter(params) {
  return http.post('/users/promoters', params);
}

export async function updatePromoter(params, id) {
  return http.put(`/users/promoters/${id}`, params);
}

export async function updatePromoterConfigs(params, id) {
  return http.put(`/users/promoters/${id}/configs`, params);
}

export async function getPromoters(id) {
  return http.get(`/users/promoters${id | 0 ? `/${id}` : ''}`);
}

export async function searchPromoters(params) {
  return http.get(`${ALT_API_URL}/users/promoters`, { params });
}

export async function searchPromotersCSV(params = null) {
  return http.get(`${ALT_API_URL}/users/promoters?output=csv`, { params });
}

export async function getIndicated({ id, params }) {
  return http.get(`/users/promoters/${id}/indicated`, { params });
}

export async function getIndicatedByPromoterID({ id, promoter_id }) {
  return http.get(`/users/promoters/${id}/indicated/${promoter_id}`, { params: { with_performance: 1 } });
}

export async function saveIndicated({ id, data }) {
  return http.post(`/users/promoters/${id}/indicated`, data);
}

export async function deleteIndicated({ id, promoter_id }) {
  return http.delete(`/users/promoters/${id}/indicated/${promoter_id}`);
}

/** Responsible */

export async function saveUser(params) {
  return http.post('/responsibles', params);
}

/**
 * Update Responsible based on account_id
 * @function updateUser
 * @param {object} params - The params with the values to be changed
 * @param {string} id - Responsible Account_id
 * @returns any
 */
export async function updateUser(params, id) {
  return http.put(`/responsibles/${id}`, params);
}

export async function active({ id, params }) {
  return http.put(`/users/${id}/toggle-activation`, params);
}

export async function getResponsible(id, params = null) {
  return http.get(`/responsibles${id | 0 ? `/${id}` : ''}`, { params });
}

export async function searchResponsible(params) {
  return http.get(`${ALT_API_URL}/responsibles`, { params });
}

export async function searchResponsibleCSV(params = null) {
  return http.get(`${ALT_API_URL}/responsibles?output=csv`, { params });
}

export async function personalData(params, id) {
  return http.post(`/responsibles/${id}/personal-data`, { ...params });
}

/** Typists */

export async function searchTypists(params) {
  return http.get('/users/typists', { params });
}

export async function getCoordUsersByID(id) {
  return http.get(`/users/responsibles/${id}/typists`);
}

export async function changePassword(params) {
  return http.put('/users/password', { ...params });
}

export async function deactiveAllUsers(id) {
  return http.post(`${ALT_API_URL}/users/promoters/${id}/deactivate-users`);
}

export async function deactivateUsers(payload) {
  return http.post('/users/deactivate', payload);
}

export async function hub() {
  const { data } = await http.get('/users/hub');
  return data;
}

/** Assignees */

export async function getAssignees(params) {
  return http.get('/private-payroll/assignees', { params });
}

/** Promoter access (multiple promoters under a single user) */

export async function getPromoterAccesses() {
  const { data } = await http.get('/users/promoter-accesses');
  return data;
}

export async function switchPromoterAccess(promoterId) {
  const { data } = await http.post('/users/promoter-accesses/switch', { promoter_id: promoterId });
  return data;
}

export async function linkPromoterAccess({ email, password }) {
  const { data } = await http.post('/users/promoter-accesses/link', { email, password });
  return data;
}

export async function getPromoterBlockHistory(id, params = {}) {
  return http.get(`/users/promoters/${id}/block-history`, { params });
}
